import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import AboveTheFold from '../components/AboveTheFold';

export default connect(
  createStructuredSelector({
    isAuthenticated: getIsAuthenticated,
  }),
  { showModal: NavBarActions.showModal },
)(AboveTheFold);
